import React, {useEffect} from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./index.css";
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
// All pages
import HomePage from "./pages/mainPage/HomePage";
import ContactPage from "./pages/ContactPage";
import DemoProductPage from "./pages/DemoProductPage";
import ScrollToTop from "./components/ScrollToTop";
import ToolsSellPage from "./pages/toolsSell/ToolsSellPage";
import WaterJetPage from "./pages/waterJet/WaterJetPage";
import XCookieConsent from "./components/XCookieConsent";
import ReactGA from "react-ga4";
import NotFound from "./pages/404/NotFound";


function intGA() {
    if (window.location.hostname === "www.mrivet.sk") {
        //PROD
        ReactGA.initialize("G-QKZ5VR7QL2");
    } else {
        //DEV
        ReactGA.initialize("G-1TPJD98ZZN");
    }
}

intGA();


function App() {
    useEffect(() => {
        const aos_init = () => {
            AOS.init({
                once: true,
                duration: 1000,
                easing: "ease-out-cubic",
            });
        };

        window.addEventListener("load", () => {
            //aos_init();
        });
        aos_init();

    }, []);


    return (
        <>
            <XCookieConsent/>
            <Router>
                <ScrollToTop>
                    <Routes>
                        <Route path="/" element={<HomePage/>}/>
                        <Route path="/predaj-naradia" element={<ToolsSellPage/>}/>
                        <Route path="/rezanie-vodnym-lucom" element={<WaterJetPage/>}/>
                        <Route path="/contact" element={<ContactPage/>}/>
                        <Route path="/get-demo" element={<DemoProductPage/>}/>
                        <Route path='*' element={<NotFound/>}/>
                    </Routes>
                </ScrollToTop>
            </Router>
        </>
    );
}

export default App;
